import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";
import { TooltipDialog } from '../../assessment-wrapper/tooltip-dialog/tooltip-dialog.component';
import { ClassificationDomain, ClassificationIndicator, ClassificationQuestion, CompletionRate } from '../models/classification-indicators.model';
import { forkJoin, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { showToast } from '../../toast.helper';
import _cloneDeep from 'lodash/cloneDeep';
import { MatMenuTrigger } from '@angular/material/menu';
import { ResourceNameService } from 'dp-formio';

declare var $: any;

@Component({
    selector: 'app-classification-indicator-question',
    templateUrl: './classification-indicator-question.component.html',
    // styleUrls: ['./classification-indicator-question.component.scss']
    encapsulation: ViewEncapsulation.None
})
export class ClassificationIndicatorQuestionComponent implements OnInit, OnDestroy {
    @Input() dir;
    @Input() data;
    @Input() orginalQuestion: ClassificationQuestion;
    @Input() domain: ClassificationDomain;
    @Input() indicator: ClassificationIndicator;
    @Input() attachmentsFormKey: string;
    @Input() viewOnly: boolean;
    @Output() loading = new EventEmitter<boolean>();
    @Output() dataChanged = new EventEmitter<{
        questionScore: number,
        domainScore: number,
        indicatorScore: number,
        question: ClassificationQuestion,
        domainCompletionRate: number,
        indicatorCompletionRate: number
    }>();
    @Output() onHistoryUpdated = new EventEmitter();
    @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;
    question: ClassificationQuestion;

    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }

    showForm = true;
    formReady = true;
    isCommentsOpen = false;

    constructor(private dialog: MatDialog,
        private toastrService: ToastrService,
        private resourceNameService: ResourceNameService,
        private translateService: TranslateService) {

    }
    ngOnInit(): void {
        this.question = _cloneDeep(this.orginalQuestion);
        this.orginalQuestion.instanceForEdit = this.question;
    }
    ngOnDestroy(): void {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
        this.orginalQuestion.instanceForEdit = null;
    }
    closeMenu() {
        this.menuTrigger.closeMenu();
    }
    historyUpdated() {
        const tempDomain = new ClassificationDomain();
        tempDomain._id = this.domain._id;
        this.question.domainObject = tempDomain;
        this.question.domainObject.indicatorObject = {
            _id: this.indicator._id,
            history: this.indicator.history
        };
        this.onHistoryUpdated.emit();
    }
    showDialog(message: string) {
        const dialogRef = this.dialog.open(TooltipDialog, {
            width: '80%',
            data: {
                dir: this.dir,
                message: this.translateService.instant(message)
            }
        });
    }

    checkValue(event) {
        //Todo : must change this to reactive 
        if (this.question.score <= 0 || this.question.score <= this.question.min || this.question.score == null) this.question.score = this.question.min || 0;
        else if (this.question.max && this.question.max < this.question.score) this.question.score = this.question.max;
        if (this.question.type == 'int' && !new RegExp(/^\d+$/).test(this.question.score + '')) this.question.score = 0;

        event.target.value = this.question.score;
    }
    checkYearInput(event, year) {
        //Todo : must change this to reactive 
        if (!event.target.value || event.target.value < 0) {
            event.target.value = 0;
            year.value = '0';
        } else year.value = event.target.value.toString();
    }

    changeApply() {
        if (this.question.notApply) this.question.resetResult();
        this.showForm = false;
        this.formReady = false;
        setTimeout(() => this.formReady = true);
    }

    formLoad(formSettings) {
        setTimeout(() => {
            const array = $('.classification-indicator-question [name="data[submit]"]');
            for (let index = 0; index < array.length; index++) {
                $(array[index]).hide();
            }
            this.showForm = true;
        }, 250);
    }
    save() {
        const completionRate = this.calcCompletionRate(this.question._id);
        const questionId = this.question._id;
        const question = this.prepareQuestion(_cloneDeep(this.question));

        const domainId = this.domain._id;
        let domain = _cloneDeep(this.domain) as ClassificationDomain;
        const questionIndex = domain.questions.findIndex(q => q._id == questionId);
        domain.questions[questionIndex] = question;
        domain = this.prepareDomain(_cloneDeep(domain));

        const indicatorId = this.data.indicator._id;
        let indicator = _cloneDeep(this.data.indicator) as ClassificationIndicator;
        const domainIndex = indicator.domains.findIndex(d => d._id == domainId);
        indicator.domains[domainIndex] = domain;
        indicator = this.prepareIndicator(_cloneDeep(indicator));

        const calls = this.prepareCalls(completionRate, questionId, question, domainId, domain, indicatorId, indicator);

        this.loading.emit(true);
        this.sub = forkJoin(calls)
            .subscribe(data => {
                this.question.isSaved = true;
                this.question.orginal = _cloneDeep(this.question);

                this.dataChanged.emit({
                    questionScore: question.score,
                    domainScore: domain.score,
                    indicatorScore: indicator.score,
                    question: this.question,
                    domainCompletionRate: completionRate.domainCompletionRate,
                    indicatorCompletionRate: completionRate.indicatorCompletionRate
                });
                this.loading.emit(false);
                showToast(this.toastrService,
                    this.translateService.instant("forms.common.Saved done"),
                    this.translateService.instant("forms.common.Saved Successfully"),
                    false
                );
            }, error => {
                this.loading.emit(false);
                showToast(this.toastrService,
                    this.translateService.instant("ErrorOccurred"),
                    this.translateService.instant("generalError"),
                    true
                );
            });
    }
    private prepareCalls(completionRate: CompletionRate, questionId, question, domainId, domain, indicatorId, indicator) {
        const calls = [];
        calls.push(this.resourceNameService.
            patchSubmission(this.data.customOptions.questionResource,
                questionId, [
                {

                    "op": "add",
                    "path": "/data/notApply",
                    "value": question.notApply
                },
                {

                    "op": "add",
                    "path": "/data/isSaved",
                    "value": true
                },
                {

                    "op": "add",
                    "path": "/data/notes",
                    "value": question.notes || ''
                },
                {

                    "op": "add",
                    "path": "/data/score",
                    "value": question.score || null
                },
                {

                    "op": "add",
                    "path": "/data/attachmentsFiles",
                    "value": question.attachmentsFiles
                },
                {

                    "op": "add",
                    "path": "/data/years",
                    "value": question.years
                }
            ]));

        calls.push(this.resourceNameService.
            patchSubmission(this.data.customOptions.domainResource,
                domainId,
                [{

                    "op": "add",
                    "path": "/data/score",
                    "value": domain.score || 0
                }, {

                    "op": "add",
                    "path": "/data/completionRate",
                    "value": completionRate.domainCompletionRate || 0
                }
                ]));

        calls.push(this.resourceNameService.
            patchSubmission(this.data.customOptions.indicatorResource,
                indicatorId,
                [{

                    "op": "add",
                    "path": "/data/score",
                    "value": indicator.score || 0
                }, {

                    "op": "add",
                    "path": "/data/completionRate",
                    "value": completionRate.indicatorCompletionRate || 0
                }
                ]));

        return calls;
    }

    private calcCompletionRate(questionId: string): CompletionRate {
        //always exclude the current question then add 1 to avoid duplicate
        let savedQuestion = this.domain.questions.filter(q => q.isSaved && q._id != questionId).length + 1;
        let domainCompletionRate = savedQuestion * 100 / this.domain.questions.length;

        //remove the old domain rate before adding the new rate
        let domainCount = this.indicator.domains.length;
        let indicatorCompletionRate = (this.indicator.completionRate - (this.domain.completionRate / domainCount)) +
            domainCompletionRate / domainCount;

        return new CompletionRate(domainCompletionRate, indicatorCompletionRate);
    }

    private prepareQuestion(data: ClassificationQuestion) {
        delete data._id;
        return data;
    }
    private prepareDomain(data: ClassificationDomain) {
        data.score = data.calculatedScore;
        delete data._id;
        delete data.isCached;
        delete data.questions;
        return data;
    }
    private prepareIndicator(data: ClassificationIndicator) {
        data.score = data.calculatedScore;
        delete data._id;
        delete data.isCached;
        delete data.domains;
        delete data.attachmentsFormKey;
        return data;
    }
}
